import { render } from "./garment-grid.vue?vue&type=template&id=0d16dc71"
import script from "./garment-grid.vue?vue&type=script&lang=js"
export * from "./garment-grid.vue?vue&type=script&lang=js"

import "./garment-grid.vue?vue&type=style&index=0&id=0d16dc71&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__